<div *ngIf="title || text"
     class="signup-tooltip theme-white-1-background"
     id="{{'tooltip-' + title}}"
     role="tooltip">
    <strong>{{ title }}</strong>
    <p>{{ text }}</p>
</div>
